import React from 'react';
import PropTypes from 'prop-types';
import GenericIcon from './fontIcons/genericIcon';
import './fontIcons/fontIconStyle.css';

const RefundIcon = ({ ...props }) => {
  const { color, size } = props;
  return (
    <GenericIcon color={color} size={size} fontClass="icon-ic_reembolso" />
  );
};

RefundIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export default RefundIcon;
